import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import {
  BrowserRouter,
  Switch,
  Redirect,
  MemoryRouter,
  Route,
  Router,
} from "react-router-dom";
import "index.css";
import AuthLayout from "layouts/Auth";
import AdminLayout from "layouts/Admin";
import DmtLayout from "layouts/DmtLayout";
import BusLayout from "layouts/BusLayout";
import HotelLayout from "layouts/HotelLayout";
import RechargeLayout from "layouts/RechargeLayout";
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from "@material-ui/core/styles";
import LandingPageLayout from "layouts/LandingPageLayout";

import AgentRegistration from "pages/agent/AgentRegistration";
import "assets/scss/material-dashboard-pro-react.scss?v=1.8.0";
import "assets/css/custom-table.css";
import FlightTicket from "pages/report/flight/FlightTicketNoHeader";
import FlightTicketPrint from "pages/report/flight/print/FlightTicketPrint";
import GroupBooking from "pages/groupBooking/GroupBooking";
import "assets/css/css-variable.css";
import AppStateProvider from "layouts/AppStateProvider";
import PackagesLayout from "layouts/PackagesLayout";

import { Provider } from "react-redux";
import { store, persistor } from "redux/store";
import { PersistGate } from "redux-persist/integration/react";
import LinearProgress from "@material-ui/core/LinearProgress";
import FlightLayout from "layouts/FlightLayout";
import PrintLayout from "layouts/PrintLayout.js";
import PreLoginLayout from "layouts/PreLoginLayout.js";
import B2clayout from "layouts/B2Clayout";
import CorporatePages from "layouts/CorporateLayout";
import AadhaarpayLayout from "layouts/AadhaarpayLayout";
import LoginPage from "pages/corporate/LoginPage";
import SpecialOffersLayout from "layouts/SpecialOffersLayout";
import { Helmet } from "react-helmet";
import { AppConstant } from "appConstant";
import OaLogout from "pages/components/OaLogout";
import InsuranceLayout from "layouts/InsuranceLayout";
import ExclusiveOffersLayout from "layouts/ExclusiveOffersLayout";
import { getSiteComponents } from "oautils/oapartnerSiteUtils";
import SplashScreen from "components/Loaders/SplashScreen";
import { siteName } from "api/ApiConstants";
import PanServiceLayout from "layouts/PanServiceLayout";

const hist = createBrowserHistory();
window.appNameContext = "psa";

const checkPartnerSiteDetails = async () => {
  ReactDOM.render(<SplashScreen />, document.getElementById("root"));
  return new Promise((resolve, reject) => {
    getSiteComponents(AppConstant, siteName)
      .then((appConst) => {
        resolve(appConst);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const isServiceAvailed = (serviceId, appConst) => {
  return appConst.serviceAvailed.includes(serviceId);
};

checkPartnerSiteDetails().then((data) => {
  const theme = createTheme(data.colors);
  ReactDOM.render(
    <MuiThemeProvider theme={theme}>
      <Helmet>
        <title>{data?.name}</title>
        <link rel="shortcut icon" href={data?.favicon} />
      </Helmet>
      <AppStateProvider appconst={data}>
        <Provider store={store}>
          <PersistGate loading={<LinearProgress />} persistor={persistor}>
            <Router history={hist} basename="/">
              <Switch>
                <Route path="/prelogin">
                  <PreLoginLayout appconst={data}/>
                </Route>
                <Route path="/print">
                  <PrintLayout appconst={data}/>
                </Route>
                <Route path="/auth">
                  <AuthLayout appconst={data}/>
                </Route>
                <Route path="/admin">
                  <AdminLayout appconst={data}/>
                </Route>
                <Route path="/registration">
                  <AgentRegistration appconst={data}/>
                </Route>
                <Route path="/packages">
                  <PackagesLayout appconst={data}/>
                </Route>
                <Route
                  path="/flightticket/:ticketId/:isAddress/:isFare/:isPerPassenger/:isGST"
                >
                  <FlightTicketPrint appconst={data}/>
                </Route>
                <Route
                  path="/flightticket/:ticketId"
                >
                  <FlightTicket appconst={data}/>
                </Route>
                <Route
                  path="/exclusive-offers"
                >
                  <ExclusiveOffersLayout appconst={data}/>
                </Route>
                <Route path="/groupbooking">
                  <GroupBooking appconst={data}/>
                </Route>
                <Route path="/b2c">
                  <B2clayout appconst={data}/>
                </Route>
                <Route path="/corporate">
                  <CorporatePages appconst={data}/>
                </Route>
                <Route path="/corporate_login">
                  <LoginPage appconst={data}/>
                </Route>
                <Route path="/fd">
                  <SpecialOffersLayout appconst={data}/>
                </Route>
                <Route path="/logout">
                  <OaLogout appconst={data}/>
                </Route>
                <Route path="/flight">
                  <FlightLayout appconst={data}/>
                </Route>
                {isServiceAvailed(2, data) && (
                  <Route path="/hotel">
                    <HotelLayout appconst={data} />
                  </Route>
                )}
                {isServiceAvailed(4, data) && (
                  <Route path="/bus">
                    <BusLayout appconst={data} />
                  </Route>
                )}
                {isServiceAvailed(17, data) && (
                  <Route path="/recharge">
                    <RechargeLayout appconst={data} />
                  </Route>
                )}
                {isServiceAvailed(6, data) && (
                  <Route path="/insurance">
                    <InsuranceLayout appconst={data} />
                  </Route>
                )}
                {isServiceAvailed(18, data) && (
                  <Route path="/moneytransfer">
                    <DmtLayout appconst={data} />
                  </Route>
                )}
                {(isServiceAvailed(21, data) ||
                  isServiceAvailed(25, data)) && (
                    <Route path="/aadhaarpay">
                      <AadhaarpayLayout appconst={data} />
                    </Route>
                )}
                {isServiceAvailed(24, data) && (
                  <Route path="/pan">
                    <PanServiceLayout appconst={data} />
                  </Route>
                )}
                <Route path="/">
                  <LandingPageLayout appconst={data}/>
                </Route>
                <Redirect from="/" to="/auth/loading-page" />
              </Switch>
            </Router>
          </PersistGate>
        </Provider>
      </AppStateProvider>
    </MuiThemeProvider>,
    document.getElementById("root")
  );
});
